import type { IconNode } from '../types';

/**
 * @name coffee-bean
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNC4wNSAxOS45NWExMS4yNCA4LjU4NSAxMzUgMCAwIDE1LjktMTUuOSAxMS4yNCA4LjU4NSAxMzUgMCAwLTE1LjkgMTUuOSIgLz4KICA8cGF0aCBkPSJNMTkuOCA0LjJDMjAgMTQgNCAxMCA0LjIgMTkuOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/coffee-bean
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coffeeBean: IconNode = [
  [
    'path',
    { d: 'M4.05 19.95a11.24 8.585 135 0 0 15.9-15.9 11.24 8.585 135 0 0-15.9 15.9', key: '96muoz' },
  ],
  ['path', { d: 'M19.8 4.2C20 14 4 10 4.2 19.8', key: '2gjs92' }],
];

export default coffeeBean;
